import { Alert, AlertIcon, Box, SlideFade, Text } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  isShown?: boolean;
}

const AskaCanceledBanner: React.FC<Props> = ({ isShown }) => {
  const { t } = useTranslation();

  return (
    <SlideFade in={isShown}>
      <Alert p="3" status="warning" mb="6">
        <AlertIcon />
        <Box>
          <Text textStyle="smallBodyMedium" color="black" mb="1">
            {t('ASKA_FINALIZE_CANCELED_BANNER_TITLE')}
          </Text>
          <Text textStyle="smallBody">
            {t('ASKA_FINALIZE_CANCELED_BANNER_DESCRIPTION')}
          </Text>
        </Box>
      </Alert>
    </SlideFade>
  );
};

export default AskaCanceledBanner;
